import config from 'lib/config';
import * as _ from 'lodash-es';

export default async function fetchGuestToken({
  email,
  uid,
}: {
  email: string;
  uid?: string;
}): Promise<{
  token: string;
}> {
  const response = await fetch(config.authTokenGeneratorUrl, {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    body: JSON.stringify(_.omit({ email, uid })),
  });
  if (!response.ok) {
    throw new Error(response.statusText);
  }

  return response.json();
}
